import getRoutesList from './routesList';

export default function (prevPath, nextPath, locale) {
  var routesList = getRoutesList(locale);
  var prevSequence = 0;
  var nextSequence = 0;
  var prevTypeLayout = '';
  var nextTypeLayout = '';
  for (var i = 0; i < routesList.length; i++) {
    var obj = routesList[i];
    if (!obj.path) {
      continue;
    }
    var path = obj.path.replace(':locale', locale);
    if (path === prevPath) {
      if (obj.sequence && obj.layoutType) {
        prevSequence = obj.sequence;
        prevTypeLayout = obj.layoutType
      }
    }
    if (path === nextPath) {
      if (obj.sequence && obj.layoutType) {
        nextSequence = obj.sequence;
        nextTypeLayout = obj.layoutType
      }
    }
  }
  var difference = prevSequence - nextSequence;
  if (prevTypeLayout !== nextTypeLayout) {
    return 'fadeComponent'
  } else {
    if (difference == 0) {
      return 'fadeComponent'
    } else {
      return difference > 0 ? 'slideComponentPrev' : 'slideComponentNext';
    }
  }
}
